<template>
  <div>
    <HighChart :options="chartOptions" />
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'

export default {
  components: {
    HighChart: Chart
  },
  props: {
    healthScoreData: Array
  },
  watch: {
    healthScoreData: function (newSeries) {
      this.chartOptions.series = newSeries
    }
  },
  data: function () {
    return {
      chartOptions: {
        chart: {
          type: 'scatter',
          zoomType: 'xy',
          zooming: {
            mouseWheel: {
              enabled: true
            }
          },
          events: {
            load () {
              const chart = this

              // Block scroll wheel unless Shift is held
              chart._wheelBlocker = (e) => {
                if (!e.shiftKey) {
                  if (e.stopImmediatePropagation) e.stopImmediatePropagation()
                  e.stopPropagation()
                }
              }
              chart.container.addEventListener('wheel', chart._wheelBlocker, { capture: true })

              // Show zoom cursor when Shift is held
              chart._cursorHint = (e) => {
                chart.container.style.cursor = e.shiftKey ? 'zoom-in' : ''
              }
              chart.container.addEventListener('mousemove', chart._cursorHint)

              // Flip cursor immediately on Shift press/release
              chart._onKeyShift = (e) => {
                if (e.key === 'Shift' && chart.container) {
                  chart.container.style.cursor = (e.type === 'keydown') ? 'zoom-in' : ''
                }
              }
              chart._offKeyDown = Highcharts.addEvent(document, 'keydown', chart._onKeyShift)
              chart._offKeyUp = Highcharts.addEvent(document, 'keyup', chart._onKeyShift)
            },
            destroy () {
              const el = this.container
              if (this._wheelBlocker && el) el.removeEventListener('wheel', this._wheelBlocker, { capture: true })
              if (this._cursorHint && el) el.removeEventListener('mousemove', this._cursorHint)
              if (this._offKeyDown) this._offKeyDown()
              if (this._offKeyUp) this._offKeyUp()
            }
          }
        },
        title: {
          text: 'Health Score'
        },
        accessibility: {
          enabled: false
        },
        credits: {
          enabled: false
        },
        lang: {
          noData: this.$t('charts.nodata')
        },
        xAxis: {
          type: 'datetime',
          ordinal: false,
          startOnTick: false,
          endOnTick: false
        },
        yAxis: {
          title: {
            text: 'Health (Power)'
          },
          plotLines: [{
            color: '#ffa500',
            width: 2,
            value: 1,
            dashStyle: 'longdash'
          }]
        },
        tooltip: {
          valueDecimals: 2,
          pointFormat: '{point.x:%Y-%m-%d %H:%M:%S}<br/>Health: <b>{point.y}</b>'
        },
        plotOptions: {
          scatter: {
            marker: {
              radius: 5,
              states: {
                hover: {
                  enabled: true,
                  lineColor: 'rgb(100,100,100)'
                }
              }
            },
            states: {
              hover: {
                marker: {
                  enabled: false
                }
              }
            }
          }
        },
        series: []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/switch/_analysis/_healthScoresGraph.vue